import React, { useEffect, useState } from "react";
import { Comment } from "../../common/Comment";
import { HtmlEditor, TextArea } from "devextreme-react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Chip,
  IconButton,
  makeStyles,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  withStyles,
} from "@material-ui/core";
//import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import { faLink, faSpinner, faHourglassHalf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Attachment } from "@material-ui/icons";
import { Position } from "devextreme-react/autocomplete";

const useStyles = makeStyles({
  stepper: {
    padding: "1rem 0",
  },
  step: {
    padding: 0,
  },
  alternativeLabel: {
    marginTop: "0.25rem !important",
  },
});

const CustomConnector = withStyles({
  alternativeLabel: {
    top: "0.5rem",
    left: "calc(-50% + 0.50rem)",
    right: "calc(50% + 0.50rem)",
  },
  line: {
    height: "0.15rem",
    border: 0,
    blockSize: "border-box",
    backgroundColor: "#71767C",
  },
})(StepConnector);

function customStepIcon(stepValue, npsValue, maxScore) {
  let color = "#EFF1F2";
  const halfValue = Math.trunc(maxScore / 2);

  if (npsValue) {
    if (stepValue < 0) {
      color = stepValue < npsValue ? "#EFF1F2" : "#D50005";
    }

    if (stepValue > 0) {
      color =
        stepValue > npsValue
          ? "#EFF1F2"
          : npsValue <= halfValue
          ? "#D50005"
          : "#007BC0";
    }

    if (stepValue == 0) {
      color = npsValue <= halfValue ? "#D50005" : "#007BC0";
    }
  }

  return (
    <div
      style={{
        width: "1rem",
        height: "1rem",
        borderRadius: "0.5rem",
        backgroundColor: color,
      }}
    ></div>
  );
}

function CommentSection(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [qmaiSteps, setQmaiSteps] = useState(["0"]);
  const qmaiUrl = window.getConfig("QMAI_URL");
  const {
    loading,
    comments,
    changeCaseComment,
    changeCaseCommentAttachments,
    removeCommentAttachment,
    current,
    currentAttachments,
    closed,
    showNewCase,
    qmaiAnalysis,
    downloadHistoryFile
  } = props;

  useEffect(() => {
    if (qmaiAnalysis && qmaiAnalysis.correlationId != undefined && qmaiSteps.length == 1) {
      if (qmaiAnalysis.maxScore > -1 && qmaiAnalysis.maxScore < 1000) {
        const rangeNum = qmaiAnalysis.maxScore > 50 ? 10 : 5;

        let stepNumber = rangeNum;
        const tempArray = [...qmaiSteps];
        while (stepNumber <= qmaiAnalysis.maxScore) {
          tempArray.push(stepNumber);
          stepNumber += rangeNum;
        }
        setQmaiSteps(tempArray);
      }
    }
  }, [qmaiAnalysis]);



const QMAIArea_NULL = () => {
  return (
    <div style={{ display: "flex", gap: "5px", alignItems: "center", color: "#007BC0", padding: "0.5rem", border: "1px solid #e6e7e7"  }}>
      <span
        style={{ fontSize: "15px", fontWeight: 700 }}
      >
        QMAI Score - {t("Analyzing")}
      </span>
      <FontAwesomeIcon icon={faHourglassHalf} color="#007bc0" />
    </div>
  )
}

  const QMAIArea = () => {
    return (
      <div className="panel-nps-info">
        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
          <div></div>
          <a
            target="_blank"
            href={`${qmaiUrl}/attendance-detail/${qmaiAnalysis.qmaiServiceId}/insight`}
            title="Link para o QMAI"
          >
            <FontAwesomeIcon icon={faLink} color="#007bc0" />
          </a>
          <span
            style={{ fontSize: "15px", fontWeight: 700 }}
            title={`Score: ${qmaiAnalysis.score}/${qmaiAnalysis.maxScore}`}
          >
            QMAI Score:
          </span>
        </div>

        <span title={`Score: ${qmaiAnalysis.score}/${qmaiAnalysis.maxScore}`}>
          <Stepper
            classes={{ root: classes.stepper }}
            connector={<CustomConnector backgroundColor={"backgroundColor"} />}
            alternativeLabel
            activeStep={null}
          >
            {qmaiSteps.map((step) => (
              <Step classes={{ horizontal: classes.step }}>
                <StepLabel
                  classes={{ label: classes.alternativeLabel }}
                  StepIconComponent={() =>
                    customStepIcon(
                      step,
                      qmaiAnalysis.score,
                      qmaiAnalysis.maxScore
                    )
                  }
                >
                  {step}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </span>
      </div>
    );
  };

  return (
    <div
      style={{
        height: "auto",
        backgroundColor: "#fff",
        display: "grid",
        padding: "0.75rem",
        gridTemplateColumns: "repeat(2, 1fr)",
        rowGap: "1rem",
        columnGap: "1rem",
        overflow: "hidden"
      }}
    >
      <div style={{position: "relative"}}>
        <TextArea
          
          height={"100%"}
          label={t("Comments")}
          labelMode="static"
          disabled={closed}
          id={"comment-textarea"}
          onValueChanged={(value) => changeCaseComment(value.value)}
          value={current}
        ></TextArea>
        {/* <HtmlEditor
            key={'contentEmail'}
            name="contentEmail"
            style={{ height: '110px', backgroundColor: '#fff' }}
            value={current}
            onValueChanged={(value) => changeCaseComment(value.value)}
          >
          </HtmlEditor> */}

        <div style={{position: "absolute", top: 0, right: 0, backgroundColor: "white", border: "1px solid #c3c2c2" }}>
          <Button
              component="label"
              variant="text"
              size="small"
              startIcon={<Attachment sx={{ fontSize: '1rem' }} />}
              sx={{ textTransform: 'none', color: '#555555', fontSize: '0.75rem', fontWeight: 600, py: 0.2, }}
            >
            Anexar Arquivos
            <input type="file" multiple hidden onChange={changeCaseCommentAttachments} />
          </Button>
          </div>
          {currentAttachments.length > 0 && (
                <Box style={{position: "absolute", bottom: 0, backgroundColor: "white", width: "100%"}} sx={{ display: 'flex', flexWrap: 'wrap', gap: ".4rem", padding: ".4rem", borderTop: '1px solid black' }}>
                  {currentAttachments.map((file, idx) => (
                    <Chip
                      key={idx}
                      label={`${file.nameMin} (${file.size})`}
                      title={file.name}
                      onDelete={() => removeCommentAttachment(idx)}
                      size="small"
                      icon={<Attachment sx={{ fontSize: '0.75rem !important' }} />}
                      sx={{ borderRadius: '2px', bgcolor: '#275aa7', height: 22, fontSize: '0.7rem', fontWeight: 600 }}
                    />
                  ))}
                </Box>
            )}
      </div>
      <div
        style={{
          height: "inherit",
          display: "grid",
          gridTemplateRows: "min-content 1fr",
          borderBottom: "1px solid black",
          overflow: "hidden"
        }}
      >
        {/* {qmaiAnalysis && qmaiAnalysis.correlationId != undefined ? QMAIArea() : QMAIArea_NULL()} */}
        <div>
          <div className="history-label">
            <span>{t("History")}</span>
          </div>
          <div style={{ height: "18rem", overflowY: "auto" }}>
            {!showNewCase ? (
              <div className="comment-area comment-historic">
                {loading ? null : comments && comments.length < 1 ? (
                  <span>No hay históricos.</span>
                ) : (
                  comments.map((e, i, a) => (
                    <div key={`historic${i}`}>
                      <Comment
                        state={e.state}
                        agent={e.agent}
                        date={e.date}
                        message={e.message}
                        files={e.files}
                        downloadHistoryFile={downloadHistoryFile}
                      />
                    </div>
                  ))
                )}
              </div>
            ) : (
              <div className="comment-area comment-historic">
                <span>No hay históricos.</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export { CommentSection };
